function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.from.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Subject } from "rxjs";
import { map, filter } from "rxjs/operators";
import { delay, TimeoutError } from "./promises";
export var READY = "ready";
export var WAITING = "waiting";

/**
 * Implements a publish/subscribe channel with an iframe.
 *
 * Protocol:
 *
 *     1. The iframe loads a page and the 'load' event is emitted. The iframe
 *        sends a message:
 *        { type: "MESSAGE_PORT_REQ" }
 *
 *     2. The parent page creates a MessageChannel and posts the MessagePort to
 *        the child iframe using window.postMessage:
 *
 *        iframe.postMessage({ type: "MESSAGE_PORT" }, "*", [msgChannel.port2])
 *
 *     3. The child iframe posts an ack message ON THE PORT:
 *
 *        { type: "MESSAGE_PORT_ACK" }
 *
 *     4. The parent and child now communicate exclusively through the
 *        MessageChannel.
 *
 *     5. If the child is unloading, it sends MESSAGE_PORT_FIN. This puts this
 *        object back into the waiting state.
 *
 *     Messages are sent through the message channel with the following schema:
 *
 *         interface Message {
 *           type: string;
 *           data: any;
 *         }
 *
 *     Example:
 *
 *         {
 *           type: "AUTOALERT_IFRAME_READY",
 *           data: {
 *             timestamp: "2018-01-01T12:00:00Z"
 *           },
 *         }
 */
export var ChildMessagePort = /*#__PURE__*/function () {
  /**
   * @param iframeDomElement - The DOM element of the IFRAME we want to message
   * @param iframeOrigin     - 
   * @param $scope           - (optional) the scope, used to call scope.$apply() after notifying subscribers
   */
  function ChildMessagePort(iframeDomElement, iframeOrigin, $scope) {
    var _this = this;
    _classCallCheck(this, ChildMessagePort);
    this._iframe = iframeDomElement; // the iframe to communicate with
    this._origin = iframeOrigin; // the expected origin of messages from the iframe
    this._$scope = $scope; // allows us to call scope.$apply()
    this._event$ = new Subject();
    this._status$ = new Subject();
    this._generateId = function () {
      var i = 0;
      return function () {
        return i++;
      };
    }();
    this._goToWaitingState();

    // Send message port if we receive a request
    window.addEventListener('message', function (event) {
      return _this._messagePortRequestHandler(event);
    });

    // Send the port immediately and again every time the page navigates
    this._iframe.addEventListener('load', function (event) {
      return _this._iframeLoadHandler(event);
    });
    this._sendMessagePortToChild();
  }

  // public methods

  /**
   * Gets an observable that fires when a message is received.
   * @returns Observable<Message>
   */
  return _createClass(ChildMessagePort, [{
    key: "message$",
    get: function get() {
      var _this2 = this;
      return this._event$.pipe(filter(function (event) {
        return _typeof(event.data) == 'object';
      }), map(function (event) {
        var data = event.data;
        var id = data.id;
        data.replyPort = {
          postMessage: function postMessage(msg) {
            var reply = _objectSpread(_objectSpread({}, msg), {}, {
              responseForId: id
            });
            _this2.postMessage(reply);
          }
        };
        return data;
      }));
    }

    /**
     * Gets an observable that fires when connection events occur.
     */
  }, {
    key: "status$",
    get: function get() {
      return this._status$.asObservable();
    }

    /**
     * Returns "ready" if we have a message port ready to send, else "waiting".
     */
  }, {
    key: "state",
    get: function get() {
      return this._port ? READY : WAITING;
    }

    /**
     * Sends an object to the iframe.
     */
  }, {
    key: "postMessage",
    value: function postMessage(data) {
      if (this.state == READY) {
        this._port.postMessage(data);
      } else {
        this._messagesAwaitingPort.push(data);
      }
    }

    /**
     * Sends an object to the iframe and expects a response
     * @param {Message} data - The message to send, must be an object
     * @param options.timeout - Timeout in milliseconds
     * @returns Promise
     */
  }, {
    key: "postRequest",
    value: function postRequest(data) {
      var _this3 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (_typeof(data) != 'object') {
        throw Error("data must be a Message object");
      }
      var id = this._generateId();
      var timeout = options.timeout || 10000;
      data.id = id;
      this.postMessage(data);
      return new Promise(function (resolve, reject) {
        // Resolve when we receive a response
        var sub = _this3.message$.pipe(filter(function (m) {
          return m.responseForId === id;
        })).subscribe(function (msg) {
          resolve(msg);
          sub.unsubscribe();
          clearTimeout(timeoutId);
        });

        // Reject if we don't receive a response in time
        var timeoutId = delay(10000).then(function () {
          sub.unsubscribe();
          reject(new TimeoutError());
        });
      });
    }

    /**
     * Subscribes a callback to messages sent by the iframe.
     * @param {Function<Event, ()>} callback
     * @returns Subscription
     */
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this4 = this;
      if (this._$scope) {
        var callbackWithApply = function callbackWithApply(data) {
          return _this4._$scope.$apply(function () {
            return callback(data);
          });
        };
        return this._event$.subscribe(callbackWithApply);
      } else {
        return this._event$.subscribe(callback);
      }
    }
  }, {
    key: "close",
    value: function close() {
      this._status$.next({
        type: "CLOSED"
      });
      this._status$.complete();
      this._event$.complete();
      if (this.state == READY) {
        this._port.close();
      }
    }

    // private methods
  }, {
    key: "_iframeLoadHandler",
    value: function _iframeLoadHandler(event) {
      if (this.state == WAITING) {
        this._sendMessagePortToChild();
      }
    }
  }, {
    key: "_goToWaitingState",
    value: function _goToWaitingState() {
      this._status$.next({
        type: "WAITING"
      });
      if (this._port) {
        this._port.close();
        this._port = null;
      }
      if (this._messagesAwaitingPort == null) {
        this._messagesAwaitingPort = [];
      }
    }
  }, {
    key: "_goToReadyState",
    value: function _goToReadyState(port) {
      var _this5 = this;
      this._status$.next({
        type: "READY"
      });
      this._port = port;
      this._port.addEventListener('message', function (event) {
        return _this5._messagePortMessageListener(event);
      });

      // Send any awaiting messages
      if (this._messagesAwaitingPort) {
        var _iterator = _createForOfIteratorHelper(this._messagesAwaitingPort),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var message = _step.value;
            this.postMessage(message);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      this._messagesAwaitingPort = null;
    }
  }, {
    key: "_messagePortRequestHandler",
    value: function _messagePortRequestHandler(event) {
      // If we're in the ready state, this message isn't for us
      if (event.source === this._iframe.contentWindow) {
        if (event.data && event.data.type == "MESSAGE_PORT_REQ") {
          this._sendMessagePortToChild();
        }
      }
    }
  }, {
    key: "_sendMessagePortToChild",
    value: function _sendMessagePortToChild() {
      var _this6 = this;
      if (this._iframe.contentWindow == null) {
        // If there's no window, we can't post to it. But we'll receive the
        // load event and resend it then.
        return;
      }

      // Create a MessageChannel, keep port1 for ourselves and send port2 to
      // the iframe
      var channel = new MessageChannel();
      channel.port1.start();

      // If the IFRAME responds with an ACK on the port, it understood the
      // MESSAGE_PORT message and will send all future messages down the port
      // instead of posting them to our window.
      var _ackHandler = function ackHandler(event) {
        if (event.data && event.data.type == "MESSAGE_PORT_ACK") {
          _this6._status$.next({
            type: "RECEIVED_MESSAGE_PORT_ACK"
          });
          _this6._goToReadyState(channel.port1);
          channel.port1.removeEventListener('message', _ackHandler);
        }
      };
      channel.port1.addEventListener('message', _ackHandler);

      // Send the newly-minted MessagePort to the IFRAME.
      this._status$.next({
        type: "SENDING_MESSAGE_PORT"
      });
      this._iframe.contentWindow.postMessage({
        type: "MESSAGE_PORT"
      }, "*", [channel.port2]);
    }
  }, {
    key: "_messagePortMessageListener",
    value: function _messagePortMessageListener(event) {
      if (event && event.data && event.data.type == "MESSAGE_PORT_FIN") {
        this._status$.next({
          type: "RECEIVED_MESSAGE_PORT_FIN"
        });
        this._goToWaitingState();
      } else {
        this._notifySubscribers(event);
      }
    }
  }, {
    key: "_notifySubscribers",
    value: function _notifySubscribers(event) {
      this._event$.next(event);
    }
  }]);
}();
function parseJsonSafe(maybeString) {
  if (typeof maybeString != 'string') {
    return maybeString;
  }
  try {
    return JSON.parse(maybeString);
  } catch (e) {
    return maybeString;
  }
}